import Header from 'inpc/components/list/InpcListHeader';
import Filters from 'inpc/components/list/InpcListFilters';
import Table from 'inpc/components/list/InpcListTable';
import Row from 'inpc/components/list/InpcListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/list/index.js